import { LoadingIcon } from "assets/Icons";
import { useTranslate } from "react-admin";

export const AnimatedLoader = ({
  withTranslation
}: {
  withTranslation?: boolean;
}) => {
  const translate = useTranslate();
  return (
    <div className="h-screen flex justify-center items-center bg-mono-primaryBgColor">
      <div className="flex flex-col justify-center items-center appearAnimation">
        <div className="loadingSpinAnimation">
          <LoadingIcon />
        </div>
        <div
          className="text-mono-primaryTextColor text-[24px]
        font-['OptimaLTStd'] font-[600] leading-8 mt-[24px]"
        >
          {withTranslation ? translate("common.please_wait") : "Please wait"}
        </div>
        <div
          className="text-mono-secondaryTextColor text-[16px]
        font-['Inter'] font-[400] leading-6"
        >
          {withTranslation
            ? translate("common.we_are_loading_data")
            : "We are loading data"}
        </div>
        <div
          className="text-mono-secondaryTextColor text-[16px]
        font-['Inter'] font-[400] leading-6"
        >
          ...
        </div>
      </div>
    </div>
  );
};
